import { LayoutWindowId } from "../Types/LayoutWindowId"

export type PendingWindowCommand = "autoscaleAfterNextViewChange"

const pendingWindowCommands = new Map<string, Set<PendingWindowCommand>>()

function mapKey(windowId: LayoutWindowId): string {
	return `${windowId.layoutId}-${windowId.windowId}`
}

export function queueWindowCommand(windowId: LayoutWindowId, command: PendingWindowCommand): void {
	const commands = pendingWindowCommands.get(mapKey(windowId)) ?? new Set<PendingWindowCommand>()
	commands.add(command)
	pendingWindowCommands.set(mapKey(windowId), commands)
}

export function consumeWindowCommand(windowId: LayoutWindowId, command: PendingWindowCommand): boolean {
	const commands = pendingWindowCommands.get(mapKey(windowId))

	if (!commands?.has(command)) {
		return false
	}

	commands.delete(command)

	if (commands.size === 0) {
		pendingWindowCommands.delete(mapKey(windowId))
	}

	return true
}

export function clearWindowCommands(windowId: LayoutWindowId): void {
	pendingWindowCommands.delete(mapKey(windowId))
}
